// --- Science Direct Technology ---

import React, { useEffect } from 'react';

interface Props {
  targetURL: string;
  adobeAnalyticsMetadata: object;
}

export default function SsoContainer({
  targetURL, adobeAnalyticsMetadata,
}: Props): JSX.Element {
  useEffect(() => {
    window.appData = window.appData ?? [];
    window.appData.push({
      event: 'productFeatureUsed',
      ...adobeAnalyticsMetadata,
    });
    // eslint-disable-next-line no-undef
    window.location.href = targetURL;
  }, []);

  return (
    <div id="sso-url-container" />
  );
}
